import setActiveProject from './setActiveProject';

export default {
	setActiveProject,
};
